import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import RenderTextField from '../../../../utils/renderFields/RenderTextField';
import { updateUser } from '../../userProfileActions';
import validate from './validate';
import { Title } from '../style';
/* eslint-disable import/no-mutable-exports */
let General = ({ handleSubmit, currentUser }) => {
  const isCompany = !!currentUser.company;
  return (
    <div>
      <Title>Informations général du compte</Title>
      <form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={7}>
          <Grid item md={5}>
            <Field
              name="firstname"
              id="firstname"
              label="Prénom"
              fullWidth
              component={RenderTextField}
            />
          </Grid>
          <Grid item md={5}>
            <Field
              name="lastname"
              id="lastname"
              label="Nom"
              fullWidth
              component={RenderTextField}
            />
          </Grid>
        </Grid>
        <Grid container spacing={7}>
          <Grid item md={5}>
            <Field
              name="email"
              id="email"
              label="Email"
              fullWidth
              component={RenderTextField}
            />
          </Grid>
          <Grid item md={5}>
            <Field
              name="companyName"
              id="companyName"
              label="Entreprise"
              disabled={!isCompany}
              fullWidth
              component={RenderTextField}
            />
          </Grid>
        </Grid>
        <Grid container spacing={7}>
          <Grid item md={5}>
            <Field
              name="companyVatNumber"
              id="companyVatNumber"
              label="Numéro de TVA"
              disabled={!isCompany}
              fullWidth
              component={RenderTextField}
            />
          </Grid>
          <Grid item md={5}>
            <Field
              name="companyRegistrationNumber"
              id="companyRegistrationNumber"
              label="Numéro de SIRET"
              disabled={!isCompany}
              fullWidth
              component={RenderTextField}
            />
          </Grid>
        </Grid>
        <Grid container justify="center" item md={10} style={{ marginTop: 90 }}>
          <Button variant="contained" color="primary" type="submit">
            Mettre à jour les informations
          </Button>
        </Grid>
      </form>
    </div>
  );
};

const mapStateToProps = state => {
  const { email, firstname, lastname, company } = state.init.currentUser;
  return {
    currentUser: state.init.currentUser,
    initialValues: {
      email,
      firstname,
      lastname,
      companyName: company ? company.name : '',
      companyRegistrationNumber: company ? company.registrationNumber : '',
      companyVatNumber: company ? company.vatNumber : ''
    }
  };
};

General.propTypes = {
  handleSubmit: PropTypes.func,
  currentUser: PropTypes.object.isRequired
};

General = reduxForm({
  form: 'userGeneralInformations',
  validate,
  onSubmit: (values, dispatch, props) => {
    const { parameters, phoneNumber } = props.currentUser;
    const userInformations = {
      ...values,
      phoneNumber,
      parameters
    };
    dispatch(updateUser(userInformations));
  }
})(General);

export default connect(mapStateToProps)(General);
